export function gorselKaynagi(yol: string): { uri: string } {
  return { uri: yol };
}
